import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ClanakListKorisnik.css";
import "../Dokument/DokumentListKorisnik.css";
import StatistikaClankaService from "../../services/statistikaClanka.service";
import { formatDateTime } from "../../utils/formatDateTime";
import dayjs from "dayjs";
import logoDark from "../../img/logo_dark.png";

function ClanakListKorisnik({ clanci }) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentClanci = clanci.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(clanci.length / itemsPerPage);
  const handleClickClanak = async (clanakId) => {
    const novaStatistika = {
      vremenskaOznaka: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
      clanakId: clanakId,
    };

    try {
      await StatistikaClankaService.addStatistikaClanka(novaStatistika);
    } catch (error) {}

    navigate(`/clanci/${clanakId}`);
  };

  return (
    <div className="documents-list-container-korisnik">
      {currentClanci.length === 0 ? (
        <p style={{ textAlign: "center", color: "#c8c3a7" }}>
          Nema dostupnih članaka.
        </p>
      ) : (
        currentClanci.map((clanak, index) => {
          const colors = ["#c9bc8d", "#f7eba8", "#babd7d", "#ded6a0"];
          const backgroundColor = colors[index % colors.length];

          return (
            <div
              key={clanak.id}
              className="dokument-kartica dokument-kartica-mala"
              style={{ backgroundColor }}
              onClick={() => handleClickClanak(clanak.id)}
            >
              <div className="kartica-sadrzaj">
                <div className="kartica-korisnik-ikona">
                
                  <img
                    src={clanak.slika ? clanak.slika : logoDark}
                    alt="Slika"
                    className="kartica-korisnik-slika"
                  />
                </div>

                <div className="kartica-tekst">
                  <div className="kartica-zaglavlje">
                    <h3 className="kartica-korisnik-naslov">{clanak.naslov}</h3>
                    <p className="kartica-datum">
                      {formatDateTime(clanak.datumObjave)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      )}

      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Prethodna
          </button>

          <span>
            Stranica {currentPage} od {totalPages}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            Sljedeća
          </button>
        </div>
      )}
    </div>
  );
}
export default ClanakListKorisnik;
